var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7181 6.35756L22.0132 16L31.7181 25.6424C31.8936 25.2757 32 24.8704 32 24.4375V7.5625C32 7.12956 31.8936 6.72425 31.7181 6.35756ZM29.1875 4.75H2.8125C2.37956 4.75 1.97425 4.85644 1.60756 5.03188L14.0115 17.3733C15.1083 18.4701 16.8918 18.4701 17.9885 17.3733L30.3924 5.03188C30.0257 4.85644 29.6204 4.75 29.1875 4.75ZM0.281875 6.35756C0.106438 6.72425 0 7.12956 0 7.5625V24.4375C0 24.8704 0.106438 25.2758 0.281875 25.6424L9.98681 16L0.281875 6.35756Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6874 17.3262L19.314 18.6995C17.4866 20.5269 14.513 20.5269 12.6856 18.6995L11.3124 17.3262L1.60742 26.9686C1.97411 27.144 2.37942 27.2505 2.81236 27.2505H29.1874C29.6203 27.2505 30.0256 27.144 30.3923 26.9686L20.6874 17.3262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsActive);
export default __webpack_public_path__ + "static/media/Contact Us-Active.379325fe40ba38785227feeaf5457a05.svg";
export { ForwardRef as ReactComponent };